import InvoiceList from './invoice.list';
import InvoiceShow from './invoice.show';

export default {
  list: InvoiceList,
  create: false,
  show: InvoiceShow,
  edit: false,
};
